/**
 * A search field: magnifier at the left, a clear control at the right once there is text, and a quiet
 * spinner while a search is running. Enter searches at once (`onSubmit`); the caller debounces typing.
 */
export function SearchBox({
  value, onChange, onSubmit, onClear, busy = false, placeholder, label, maxLength = 40,
}: {
  value: string;
  onChange: (next: string) => void;
  onSubmit: () => void;
  onClear: () => void;
  busy?: boolean;
  placeholder: string;
  label: string;
  maxLength?: number;
}) {
  return (
    <form
      role="search" aria-label={label} className="mk-searchbox"
      onSubmit={(e) => { e.preventDefault(); onSubmit(); }}
    >
      <svg className="mk-searchbox-ico" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden>
        <circle cx="11" cy="11" r="6.5" /><path d="m16 16 4.5 4.5" strokeLinecap="round" />
      </svg>
      <input
        type="text" inputMode="search" autoComplete="off" value={value} placeholder={placeholder}
        aria-label={label} maxLength={maxLength} onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Escape' && value) { e.preventDefault(); onClear(); } }}
      />
      {busy ? <span className="mk-searchbox-busy" role="status" aria-label="Searching" /> : null}
      {value ? (
        <button type="button" className="mk-searchbox-clear" aria-label="Clear search" onClick={onClear}>×</button>
      ) : null}
    </form>
  );
}
